import React, { useState } from 'react'

import bg from '../../Images/Group 1171279366 (3).png'
import QuaterlyPlan from './QuaterlyPlan'
import QuarterlyComparePlan from './QuaterlyComparePlan'
import MonthlyComparePlan from './MonthlyComparePlan'
import YearlyComparePlan from './YearlyComparePlan.jsx'
import MontlyPlan from './MontlyPlan.jsx'
import YearlyPlan from './YearlyPlan.jsx'
const Plans = () => {
  const [toggle,setToggle]=useState({
    toggle1:true,
    toggle2:false,
    toggle3:false,
  })
   return (
    <>
      <section className='pricing_plans_section'>
      <img className='price_bgimg' src={bg}/>
      <div className='pricing_plans_div_head_wrapper'>
               <div className='pricing_plan_head' style={{
                cursor:'pointer'
               }}>
                 <div className={toggle.toggle1 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>setToggle({
                  toggle1:true,

                 }))}>Quarterly</div>
                 <div className={toggle.toggle2 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>{
                  setToggle({
                    toggle1:false,
                    toggle2:true,
                    toggle3:false,
                  })
                 })}>Montly</div>
                 <div className={toggle.toggle3 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>{
                  setToggle({
                    toggle1:false,
                    toggle2:false,
                    toggle3:true,
                  })
                 })}>Half-Yearly</div>
               </div>
      </div>
{toggle.toggle1 && <QuaterlyPlan/>}
{toggle.toggle1 && <QuarterlyComparePlan/>}
{toggle.toggle2 && <MontlyPlan/>}
{toggle.toggle2 && <MonthlyComparePlan/>}
{toggle.toggle3 && <YearlyPlan/>}
{toggle.toggle3 && <YearlyComparePlan/>}
      </section>
    </>
  )
}

export default Plans
